var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-xs-center"},[_c('v-progress-circular',_vm._b({},'v-progress-circular',_vm.componentProps,false)),_c('div',{staticClass:"title pa-3"},[_vm._v("\n        "+_vm._s(_vm.$t(this.waitingText))+"\n    ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }